import { useDispatch, useSelector, useStore } from 'react-redux'
import type { AppDispatch, AppStore, RootState } from 'src/index'
import type { Store } from "@reduxjs/toolkit";

export interface IAppStore extends Store {
    asyncReducers: { [key: string]: object };
    injectReducer: (key: string, asyncReducer: object) => void;

}

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>()